import Pusher from 'pusher-js';

export default Pusher